import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getDeviceIdFromCookie, setDeviceAuthCookie, getDeviceAuthFromCookie } from '../utils/deviceFingerprint';

// Verify if the device is authorized
export const verifyDevice = async (): Promise<boolean> => {
  try {
    // Check if device auth status is already in cookie
    const authFromCookie = getDeviceAuthFromCookie();
    if (authFromCookie) {
      return true;
    }
    
    // If not, verify with server
    const deviceId = getDeviceIdFromCookie();
    if (!deviceId) {
      return false;
    }
    
    const response = await axios.post(`${API_BASE_URL}/device/verify`, { deviceId });
    const isAuthorized = response.data.isAuthorized || false;
    
    // Store the result in cookie
    setDeviceAuthCookie(isAuthorized);
    
    return isAuthorized;
  } catch (error) {
    console.error('Device verification failed:', error);
    // In case of error, default to unauthorized
    setDeviceAuthCookie(false);
    return false;
  }
};